import React from 'react';
import SEO_CONFIG from '../Config/seoConfig';

const EnvironmentIndicator = () => {
  // Only show in non-production environments
  if (SEO_CONFIG.isProduction()) return null;
  
  const envType = SEO_CONFIG.isDevelopment() ? 'DEVELOPMENT' : 
                 SEO_CONFIG.isPreview() ? 'PREVIEW' : 'UNKNOWN';
  
  const bgColor = SEO_CONFIG.isDevelopment() ? '#ff6b6b' : '#feca57';
  
  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: bgColor,
      color: 'black',
      textAlign: 'center',
      padding: '4px 8px',
      fontSize: '12px',
      fontWeight: 'bold',
      zIndex: 9999,
      fontFamily: 'monospace'
    }}>
      {envType} - SEO DISABLED | Production: prawnhub.xyz
    </div>
  );
};

export default EnvironmentIndicator;
